import axios from 'axios';

const api = axios.create({
  baseURL: localStorage.getItem('isInternal') !== '1'
    ? process.env.VUE_APP_API_URL
    : process.env.VUE_APP_API_GRP_URL,
});

export default api;
